import React, { useEffect } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import LoadingScreen from './components/LoadingScreen';
import { db, auth } from "./config/firebase";
import { doc, getDoc, updateDoc, arrayUnion } from "firebase/firestore";
import { signInAnonymously } from "firebase/auth";

function GroupChecker() {
    const { group, course } = useParams();
    const navigate = useNavigate();

    // Only set localStorage if we have valid group and course
    if (group && course) {
        localStorage.setItem("group", group);
        localStorage.setItem("course", course);
    }

    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged(async function (user) {
            if (!group || !course) {
                navigate("/", { replace: true });
                return;
            }

            if (user && user.isAnonymous === false) {
                try {
                    const userRef = doc(db, 'users', user.uid);
                    const userDoc = await getDoc(userRef);

                    if (userDoc.exists()) {
                        const userData = userDoc.data();
                        const hasCourse = userData.courses?.some(c => c.course === course && c.group === group);

                        if (!hasCourse) {
                            await updateDoc(userRef, {
                                courses: arrayUnion({
                                    course: course,
                                    group: group
                                })
                            });
                        }
                        navigate("/page/teetimes", { replace: true });
                    } else {
                        navigate("/", { replace: true });
                    }
                } catch (error) {
                    console.error("Error checking user data:", error);
                    navigate("/", { replace: true });
                }
            } else {
                try {
                    await signInAnonymously(auth);
                    navigate("/", { replace: true });
                } catch (error) {
                    console.error("Error signing in anonymously:", error);
                    navigate("/", { replace: true });
                }
            }
        });

        return () => unsubscribe();
    }, [group, course, navigate]);

    return <LoadingScreen />;
}

export default GroupChecker
